import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

export default function AdminSecurityDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api("/api/admin/security/overview")
      .then(setData)
      .catch((err) => setError(err.message));
  }, []);

  const cards = [
    ["Total Admins", data?.total_admins || 0],
    ["Active Admins", data?.active_admins || 0],
    ["Blocked Admins", data?.blocked_admins || 0],
    ["Audit Logs", data?.total_logs || 0],
    ["Logs in 7 Days", data?.logs_7_days || 0],
    ["Failed Login 24h", data?.failed_logins_24h || 0],
  ];

  return (
    <AdminLayout
      title="Security Center"
      subtitle="Monitor admin access, hardening controls, backups and recent security events."
      actions={
        <>
          <Link to="/adxm/audit-logs" className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-bold text-white">Activity Logs</Link>
          <Link to="/adxm/backups" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-bold text-white">Backup Center</Link>
        </>
      }
    >
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}

      <div className="grid gap-4 md:grid-cols-3 xl:grid-cols-6">
        {cards.map(([label, value]) => (
          <div key={label} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <p className="text-xs font-black uppercase tracking-wider text-slate-500">{label}</p>
            <p className="mt-3 text-3xl font-black text-slate-950">{value}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
          <h2 className="text-xl font-black text-slate-950">Hardening Status</h2>
          <div className="mt-4 grid gap-3">
            {Object.entries(data?.hardening || {}).map(([key, value]) => (
              <div key={key} className="flex items-center justify-between rounded-2xl bg-slate-50 p-4">
                <span className="font-bold capitalize text-slate-700">{key.replaceAll("_", " ")}</span>
                <span className={value ? "rounded-full bg-emerald-100 px-3 py-1 text-xs font-black text-emerald-700" : "rounded-full bg-red-100 px-3 py-1 text-xs font-black text-red-700"}>
                  {value ? "Enabled" : "Disabled"}
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
          <h2 className="text-xl font-black text-slate-950">Recent Activity</h2>
          <div className="mt-4 space-y-3">
            {(data?.recent_logs || []).map((log) => (
              <div key={log.id} className="rounded-2xl border border-slate-200 p-4">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-slate-900 px-3 py-1 text-xs font-black uppercase text-white">{log.action}</span>
                  <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700">{log.module}</span>
                </div>
                <p className="mt-2 font-semibold text-slate-800">{log.description}</p>
                <p className="mt-1 text-xs text-slate-500">{log.admin_name || log.admin_email || "System"} • {new Date(log.created_at).toLocaleString()}</p>
              </div>
            ))}
            {(!data?.recent_logs || data.recent_logs.length === 0) && <p className="text-slate-500">No activity yet.</p>}
          </div>
        </section>
      </div>
    </AdminLayout>
  );
}
